module.exports = __webpack_public_path__ + "img/age-confirm-main-img.e557fe7c.jpg";